import React from 'react';

import { createIcon } from '@chakra-ui/react';

import { EColor } from '../Theme';

export const LogOutIcon = createIcon({
  viewBox: '0 0 20 20',
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M12.7441 6.91058C13.0695 6.58514 13.5972 6.58514 13.9226 6.91058L16.4226 9.41058C16.748 9.73602 16.748 10.2637 16.4226 10.5891L13.9226 13.0891C13.5972 13.4145 13.0695 13.4145 12.7441 13.0891C12.4187 12.7637 12.4187 12.236 12.7441 11.9106L13.8215 10.8332H10C9.53978 10.8332 9.16669 10.4601 9.16669 9.99984C9.16669 9.5396 9.53978 9.1665 10 9.1665H13.8215L12.7441 8.08909C12.4187 7.76366 12.4187 7.23602 12.7441 6.91058Z"
        fill={EColor.Black}
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M3.33331 4.1665C3.33331 2.78579 4.4526 1.6665 5.83331 1.6665H14.1666C15.5474 1.6665 16.6666 2.7858 16.6666 4.1665V4.99984C16.6666 5.46007 16.2936 5.83317 15.8333 5.83317C15.3731 5.83317 15 5.46007 15 4.99984V4.1665C15 3.70626 14.6269 3.33317 14.1666 3.33317H5.83331C5.37308 3.33317 4.99998 3.70627 4.99998 4.1665V15.8332C4.99998 16.2934 5.37307 16.6665 5.83331 16.6665H14.1666C14.6269 16.6665 15 16.2934 15 15.8332V14.9998C15 14.5396 15.3731 14.1665 15.8333 14.1665C16.2936 14.1665 16.6666 14.5396 16.6666 14.9998V15.8332C16.6666 17.2139 15.5474 18.3332 14.1666 18.3332H5.83331C4.45261 18.3332 3.33331 17.2139 3.33331 15.8332V4.1665Z"
        fill={EColor.Black}
        fillRule="evenodd"
      />
    </>
  ),
});
